module.exports = __webpack_public_path__ + "img/chevron-up.ef1cfd2a.svg";